import * as sagaEffects from 'redux-saga/effects';

import handleVenuesRequestSaga from './handleVenuesRequestSaga';

const { all } = sagaEffects;

export default function* () {
    yield all([handleVenuesRequestSaga()]);
}
